import { generateKeyBetween } from 'fractional-indexing';
import type { PlannedGoal } from './types';

export function getSortedKeys(plannedGoals: PlannedGoal[]): string[] {
  const keys = plannedGoals.map((pg) => pg.sortKey);
  return keys.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
}

export function computeSortKey(
  sortedKeys: string[],
  insertAtPosition: number,
): string {
  const before = sortedKeys[insertAtPosition - 1] ?? null;
  const after = sortedKeys[insertAtPosition] ?? null;
  return generateKeyBetween(before, after);
}

export function computeSortKeys(
  sortedKeys: readonly string[],
  insertAtPosition: number,
  count: number,
): string[] {
  const working = [...sortedKeys];
  const result: string[] = [];
  for (let i = 0; i < count; i++) {
    const key = computeSortKey(working, insertAtPosition + i);
    working.splice(insertAtPosition + i, 0, key);
    result.push(key);
  }
  return result;
}
